/**
 * Entry point: publish the analytics API onto `window`.
 *
 * The callers are gateme/media/user2.js -- a global-scope classic script -- and
 * inline <script> blocks in user/show_event.html, show_event_popup.html and
 * show_event_embed.html. None of them can `import`, so `window` is the
 * interface, and this block is the whole of what they may call. Anything not
 * listed here is internal and free to change.
 *
 * user/base.html loads this bundle as a plain classic script immediately before
 * main.js and user2.js, near the end of <body>. Classic scripts execute in
 * document order and all of them before DOMContentLoaded, so these assignments
 * have happened before user2.js runs and before any $(document).ready handler
 * fires. See the README: do not make this tag async, defer or type="module".
 */
import { claimPurchaseForTracking, trackPurchaseOnce } from './claims';
import { gatemeAfterTracking, trackEvent, trackUserEvent } from './senders';

const api = {
  trackEvent,
  trackUserEvent,
  claimPurchaseForTracking,
  trackPurchaseOnce,
  gatemeAfterTracking,
};

window.trackEvent = trackEvent;
window.trackUserEvent = trackUserEvent;
window.claimPurchaseForTracking = claimPurchaseForTracking;
window.trackPurchaseOnce = trackPurchaseOnce;
window.gatemeAfterTracking = gatemeAfterTracking;

// The same functions under one name, for new code and for poking at it in the
// console without having to know which globals we happen to have taken.
window.__gatemeAnalytics = api;

export { AnalyticEvents } from './events';
export type { AnalyticEventName } from './events';
export type { TrackUserEventPayload } from './senders';
export { api };
